import React, { PureComponent } from 'react';
import $ from 'jquery';
import _, { capitalize, isEmpty, toLower, toUpper } from 'lodash';
import shortid from 'shortid';
import * as deviceInfoService from '../utils/general/deviceInfoService';
import * as HTML_RENDITION from '../utils/general/general';
import * as MENU_CHECK from './../sidepart/leftMenuRelated/menuGeneralCheck';
import { osdetect } from '../utils/general/deviceDetect';
import { getCopyHeadline } from '../utils/api/appControl';
import { IReducerState } from '../states/renditionStates';
import { connect } from 'react-redux';
import commonStore from '../store/commonStore.js';
import * as commonStateAction from '../actions/commonStateAction';
import { RenditionLoadable } from '../utils/general/LoadableRelated';
import { RSCH_HTML_TRACKING_CONFIG } from '../readership/trackingConfig';
import { switchPage } from '../utils/api/pageControl';
import LeftMenuPartTemplate from '../sidepart/leftMenuPartTemplate';
import cx from "classnames";
import {isPremiumBranding } from '../utils/general/general';
import RenditionUrlGenerator from '../utils/api/renditionUrlGenerator';

const TOCContainer = RenditionLoadable({
  loader: () => import('../sidepart/leftMenuRelated/tableOfContents'),
}, "tableOfContents", Date.now());

const TagsContainer = RenditionLoadable({
  loader: () => import('../sidepart/leftMenuRelated/tags'),
}, "tags", Date.now());

const MoreContainer = RenditionLoadable({
  loader: () => import('../sidepart/leftMenuRelated/moreTab'),
}, "moreTab", Date.now());

const PrintTabContainer = RenditionLoadable({
  loader: () => import('../sidepart/leftMenuRelated/printTab'),
}, "printTab", Date.now());

interface IHeaderProps {
  htmlBannerText: string;
  docHeaderSectionJson: any;
  initialData: any;
  menuPaneStatus: string;
  offTheCuffTitle: string | undefined;
  expandAll: boolean;
  showOldBranding: boolean;
  isFetching: boolean;
  showLHS:boolean;
  docTitle: string;
}

interface IHeaderStatus {
  isDeviceScreenType: boolean;
  showLeftFloatPanel: boolean;
}

export class Header extends PureComponent<IHeaderProps, IHeaderStatus> {

  constructor(props: IHeaderProps) {
    super(props);
    this.state = {
      isDeviceScreenType: false,
      showLeftFloatPanel: false
    };
  }

  public componentDidMount() {
    this.scrollEvent();
    !deviceInfoService.isDeviceScreenType() && this.responsiveHeader();
    deviceInfoService.isDeviceScreenType() ? this.setState({isDeviceScreenType: true}) : this.setState({isDeviceScreenType: false});
    window.addEventListener('resize', _.throttle(_.bind(this.handleThrottle, this), 200));
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', _.throttle(_.bind(this.handleThrottle, this), 200));
  }

  public handleThrottle() {
    !deviceInfoService.isDeviceScreenType() && this.responsiveHeader();
    this.checkInfoPane();
    deviceInfoService.isDeviceScreenType() ? this.setState({isDeviceScreenType: true}) : this.setState({isDeviceScreenType: false});
  }

  public responsiveHeader() {
    commonStore.dispatch(commonStateAction.menuPaneStatus(''));
    $('#rightPartContain').removeAttr("style");
  }

  public scrollEvent() {
    const whiteBar = $('#white-bar');
    const backToTop = $('#back-to-top');
    const mainView = $("body #mainView");
    const _body = $('body');
    const processBar = $("#process-bar");
    const mainDiv: any = $('#mainDiv');
    const scrollTarget: any = (deviceInfoService.isIE() && HTML_RENDITION.isAppInsideIFrame()) ? _body : $(window);
    let timeout: any = null;
    scrollTarget.on('scroll.whiteBarScroll mousewheel.whiteBarScroll', (e: any) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        const top = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
        const offCuffBanner: any = $('#offcuff-banner');
        if (top > 5) {
          whiteBar.removeClass('hide');
          offCuffBanner.addClass('hide');
          backToTop.show().prop('hidden', false);
          this.setState({showLeftFloatPanel: true})
        } else {
          whiteBar.addClass('hide');
          offCuffBanner.removeClass('hide');
          backToTop.hide().prop('hidden', true);
          this.setState({showLeftFloatPanel: false})
        }
        if (osdetect && (!osdetect.detectSmartPhone() && !osdetect.detectTablet())) {
          const bodyHeight: any = (deviceInfoService.isIE() && HTML_RENDITION.isAppInsideIFrame()) ? mainView.height() : _body.height();
          const winheight: any = $(window).height();
          const disclosureHeight: any = $('#disclosures').height();
          let fullScrollTop = bodyHeight - disclosureHeight - winheight - 128;
          const currentScrollTop = scrollTarget.scrollTop();
          if (fullScrollTop <= 0) {
            fullScrollTop = currentScrollTop;
          }
          const totalScroll = (currentScrollTop / fullScrollTop) * 100;
          processBar.css("width", totalScroll + "%");
        }
        if ((($('.infoPane') as any).height() < mainDiv.height())) {
          // Important!!! only use this setTimeout can set #rightPane scrollTop in IE after #financialsBlock height change!
          setTimeout(() => {
            $('#rightPane').removeClass('scrollIndependent');
            $('#rightPane').prop("scrollTop", top);
          }, 100);
        } else {
          $('#rightPane').addClass('scrollIndependent');
        }
      }, 20);
    });
  }

  public checkInfoPane() {
    if (HTML_RENDITION.isPresentation() && deviceInfoService.isDeviceScreenType()) {
      if ($('#slider').hasClass('collapsed')) {
        $('#slider').click();
        $('#rightPane').removeClass('slideInRight');
      }
      $('#rightPartContain').hide();
      commonStore.dispatch(commonStateAction.menuPaneStatus(''));
      return;
    }

    if (!HTML_RENDITION.isPresentation() && !deviceInfoService.isDeviceScreenType()) {  // show rightpane if it's not ppt in pc view
      $('#rightPartContain').show();
    }
  }

  public topPaneEvent(e: React.MouseEvent) {
    const parentEl: any = e.currentTarget.parentElement;
    const infoTabLi: any = document.getElementById('infoTabLi');
    const _pageName = commonStore.getState().commonStateReducer.switchPageData.pageName;
    e.preventDefault();

    if (e.currentTarget.id === 'citiBackTabBtn') {
      if (_pageName === 'mainPage') return;
      switchPage('backToMainPage');
      $('#menu_ul>li').removeClass('disabled');
      return;
    }

    commonStore.dispatch(commonStateAction.menuPaneStatus(e.currentTarget.id));

    if (e.currentTarget.id === 'infoTabButton' && parentEl.classList.contains('inactive')) {
      if ($('#slider').hasClass('collapsed')) {
        $('#slider').click();
        $('#rightPane').removeClass('slideInRight');
      }
      $('#rightPartContain').show();
      return;
    }

    if (this.props.menuPaneStatus === e.currentTarget.id || parentEl.classList.contains('disabled')) {
      commonStore.dispatch(commonStateAction.menuPaneStatus(''));
      $('#rightPartContain').hide();
      return;
    }

    if (infoTabLi.classList.contains('active')) {
      $('#rightPartContain').hide();
      return;
    }
  }

  public shouldDisableINFOMenu(pageName: any) {
    return (
      pageName === 'labelsPage' ||
        (this.props.initialData.productType !== 'blog' && pageName === 'cookiesPolicyPage') ?
        'disabled' :
        ''
    );
  }

  public shouldDisableTOCMenu(pageName: any) {
    return pageName !== 'mainPage' ? 'disabled' : '';
  }

  public shouldDisableTAGMenu(pageName: any) {
    return pageName !== 'mainPage' && pageName !== 'labelsPage' ? 'disabled' : '';
  }

  public showHeaderText() {
    if (window.HTML_RENDITION.initialData.isGlobalInsights) {
      return "Global Insights";
    }
    if (window.HTML_RENDITION.initialData.isGPS) {
      return this.props.docHeaderSectionJson.metadata.productName;
    }
    if (window.HTML_RENDITION.initialData.isNonRSCHReplay) {
      return 'Event Replay';
    }
    return 'Citi Research';
  }

  public productLabel () {
    const productName = this.props.initialData.productName;
    let htmlBannerText = this.props.htmlBannerText; // from RDH https://uat.citivelocity.com/rdhub/v1/?uri=PUBLICATION_DATA_HTMLQ_2&SUBMISSIONID=
    if (productName && htmlBannerText && (htmlBannerText.toUpperCase() == 'FYI' || htmlBannerText.toUpperCase() == 'BLOG')){
      htmlBannerText = productName; // convert productCode to productName
    }
    let bannerText = this.props.initialData.isFAVE ?
                      (htmlBannerText.toUpperCase() == 'VWPOINT' ? 'Viewpoint' : htmlBannerText) :
                      htmlBannerText;
    if(this.props.showOldBranding) {
      bannerText = this.props.initialData.isFAVE ?
                       (htmlBannerText.toUpperCase() == 'VWPOINT' ? 'V I E W P O I N T' : htmlBannerText.toUpperCase().split('').join(' ')) :
                       htmlBannerText;
    }
    if (productName && htmlBannerText && (htmlBannerText.toUpperCase() == 'BLOG' || this.props.initialData.productType === 'blog')){
        bannerText = this.props.docHeaderSectionJson.metadata.productName.toUpperCase();
    }
    if (this.props.initialData.isNonRSCHReplay || this.props.initialData.isGPS){
      return;
    }
    let labelStructure = this.props.htmlBannerText &&
    (
      <span className={this.props.initialData.isFAVE ? 'faveBannerText' : ''}>
        {this.props.showOldBranding && <span className='pipeline'> | </span>}
        <span className='html_banner_text'>{this.props.showOldBranding ? bannerText : capitalize(bannerText)}</span>
        {!this.props.showOldBranding && <span className='pipeline'> | </span>}
      </span>
    );

    if (htmlBannerText?.toUpperCase() === 'MARKETINGHANDOUT' || htmlBannerText?.toUpperCase() === 'MARKETING HANDOUT'){
      labelStructure = (<span className={this.props.initialData.isFAVE ? 'faveBannerText' : ''}></span>);
    }

    if (HTML_RENDITION.isPreview() && this.props.initialData.isFAVE) {
      // preview's htmlBannerText = '', when the page opened is a preview doc, the isPreview() returns 'true', and when it's not a previewed one, the data here is undefined
      let preivewBannerText =  '';
      if (this.props.initialData.productType.toUpperCase() == 'VWPOINT') {
        preivewBannerText = 'VIEWPOINT';
      } else if (this.props.initialData.productType.toUpperCase() == 'COMPENDIUM') {

        htmlBannerText = this.props.docHeaderSectionJson.metadata.htmlBannerText;
        if (!_.isEmpty(htmlBannerText)) {
          preivewBannerText = htmlBannerText;
        } else {
          preivewBannerText =  !this.props.docHeaderSectionJson.metadata.isJP ? 'EQUITIES' : '株式';
        }
      } else if (productName && (this.props.initialData.productType.toUpperCase() == 'FYI' || this.props.initialData.productType.toUpperCase() == 'BLOG')){
        preivewBannerText = productName;
      } else {
        preivewBannerText = this.props.initialData.productType;
      }

      // preivewBannerText = preivewBannerText.toUpperCase().split('').join(' ');
      if (productName && this.props.initialData.productType.toUpperCase() == 'BLOG'){
        preivewBannerText = productName.toUpperCase();
      }
      labelStructure = (<span className='faveBannerText'>
                          {this.props.showOldBranding && <span className='pipeline'> | </span>}
                          <span className='html_banner_text'>{this.props.showOldBranding ? preivewBannerText : capitalize(preivewBannerText)}</span>
                          {!this.props.showOldBranding && <span className='pipeline'> | </span>}
                        </span>);
      if (this.props.initialData.productType?.toUpperCase() == 'MARKETINGHANDOUT' || this.props.initialData.productType?.toUpperCase() == 'MARKETING HANDOUT'){
        labelStructure = (<span className='faveBannerText'></span>);
      }
    } else if (window.HTML_RENDITION.initialData.isGlobalInsights) {
      if (this.props.docHeaderSectionJson.metadata.contentGroup){
        labelStructure = (<span className='faveBannerText'>
          {this.props.showOldBranding && <span className='pipeline'> | </span>}
          <span className='html_banner_text'>{this.props.showOldBranding ? this.props.docHeaderSectionJson.metadata.contentGroup : capitalize(this.props.docHeaderSectionJson.metadata.contentGroup)}</span>
          {!this.props.showOldBranding && <span className='pipeline'> | </span>}
        </span>);
        if (this.props.initialData.productType?.toUpperCase() === 'MARKETINGHANDOUT' || this.props.initialData.productType?.toUpperCase() == 'MARKETING HANDOUT'){
          labelStructure = (<span className='faveBannerText'></span>);
        }
      } else {
        labelStructure = (<span className='faveBannerText'></span>);
      }
    }
    if (HTML_RENDITION.isCitiExpress()) {
      const docName = window?.HTML_RENDITION?.initialData?.templateCode?.replace(/([a-z])([A-Z])/g, '$1 $2');
      const capitalizeDocName = docName?.split(' ')?.map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
      if (!this.props.showOldBranding)  labelStructure = (
        <span className='faveBannerText'>
          <span className='html_banner_text'>{capitalizeDocName}</span>
          <span className='pipeline'> | </span>
        </span>
      );
      else labelStructure = <></>;
    }

    return labelStructure;
  }

  public headerPcScreen() {
    const { docHeaderSectionJson } = this.props;
    if (window.HTML_RENDITION.initialData.isGPS){
        return (
              <React.Fragment>
                <div id='gps_banner' className="hidden-xs">
                    <div className="gps-logo"></div>
                    <div className="gps-branding-text">{this.showHeaderText()}</div>
                    <div className="citi-logo"></div>
                </div>
              </React.Fragment>
            );
    }
    const isPremiumBrandingPresent = isPremiumBranding(docHeaderSectionJson);
    const cssClasss = cx("citi_logo",{
        "branding-present": isPremiumBrandingPresent,
        "branding-not-present": !isPremiumBrandingPresent,
    });
    const corporateLogo = 'corporateLogo' in docHeaderSectionJson ? docHeaderSectionJson.corporateLogo : null;
    const bankhCorporateLogoUrl = process.env.NODE_ENV === "development" ? docHeaderSectionJson.i18n.corporateLogoUatUrl : docHeaderSectionJson.i18n.corporateLogoProdUrl;
    // const corporateLogoUrl = !isEmpty(corporateLogo) && !isEmpty(corporateLogo.url) ? toLower(corporateLogo.value) !== "bankh" ? corporateLogo.url : bankhCorporateLogoUrl : '';
    const corporateLogoUrl = !isEmpty(corporateLogo) && !isEmpty(corporateLogo.url) ? corporateLogo.url : '';	      
   
    return (
      <React.Fragment>
        {!this.props.showOldBranding && <div id='rsch_banner' style= {this.state.showLeftFloatPanel? {display: 'none'}: {}}  className="hidden-xs">
          <div className='header_left_text' tabIndex={0}>
            {
              this.productLabel()
            }
            <span className='citi_research_text'>{this.showHeaderText()}</span>
          </div>
          <span className={cssClasss} role="img" aria-label="citi logo"></span>
          { !isEmpty(corporateLogo) && !isEmpty(corporateLogo.value) && !isEmpty(corporateLogoUrl) &&
            <img className={!isEmpty(corporateLogo) && !isEmpty(corporateLogo.value) ? toUpper(corporateLogo.value) : ''} id={"corporateLogoItem"} aria-label={`corporate logo of ${corporateLogo.value}}`} src={corporateLogoUrl}></img>
          }
        </div>}
        {this.props.showOldBranding && <div id='rsch_banner' className="hidden-xs">
          <div className='header_left_text' tabIndex={0}>
            <span className='citi_research_text'>{this.showHeaderText()}</span>
            {
              this.productLabel()
            }
          </div>
          <span className='citi_logo' role="img" aria-label="citi logo"></span>
          <img className={!isEmpty(corporateLogo) && !isEmpty(corporateLogo.value) ? corporateLogo.value : ''} src={!isEmpty(corporateLogo) && !isEmpty(corporateLogo.url) ? corporateLogo.url : ''}></img>
        </div>}
        {this.whiteBar()}
      </React.Fragment>
    );
  }

  public headerMobileScreen() {
    const bodyEl: HTMLBodyElement = document.getElementsByTagName('body')[0];
    const _pageName = commonStore.getState().commonStateReducer.switchPageData.pageName;
    this.props.menuPaneStatus === '' ? bodyEl.style.overflow = 'auto' : bodyEl.style.overflow = 'hidden';
    const initialData = this.props.initialData;
    const { docHeaderSectionJson } = this.props;
    const corporateLogo = 'corporateLogo' in docHeaderSectionJson ? docHeaderSectionJson.corporateLogo : null;
    const bankhCorporateLogoUrl = process.env.NODE_ENV === "development" ? docHeaderSectionJson.i18n.corporateLogoUatUrl : docHeaderSectionJson.i18n.corporateLogoProdUrl;
    // const corporateLogoUrl = !isEmpty(corporateLogo) && !isEmpty(corporateLogo.url) ? corporateLogo.value !== "BANKH" ? corporateLogo.url : bankhCorporateLogoUrl : '';
    let corporateLogoUrl = !isEmpty(corporateLogo) && !isEmpty(corporateLogo.url) ? corporateLogo.url : '';
    if (corporateLogoUrl.includes("ir.citi.com/")) {
      corporateLogoUrl = corporateLogoUrl.replace("ir.citi.com/", "ir.citi.com/colo/");
      var ajaxPromise = RenditionUrlGenerator.URL_GENERATOR.generateAuthFileLinkPublicURL(corporateLogoUrl);
      ajaxPromise.done(function (result : any){
        if (result) {
          corporateLogoUrl = result.url;
        }
      }.bind(this));
    }
   
    return (
      <div id='topPane' className="visible-xs col-md-12">
        <div id="menuPane" className="">
          <div className="row menuPaneCustomRow">
            <ul className="nav nav-tabs custom-tabs" id="menu_ul">
              <li id="citiBackTabLi" title={this.props.docHeaderSectionJson.i18n.tooltip_home} key={shortid.generate()}>
                <a id="citiBackTabBtn" aria-label="back tab button" role="button" onClick={(e) => this.topPaneEvent(e)}></a>
              </li>
              { 
                !isEmpty(corporateLogo) && !isEmpty(corporateLogo.value) && !isEmpty(corporateLogoUrl) &&
                <li id="corporateLogoLi" title={`corporate logo of ${corporateLogo.value}`} key={shortid.generate()}> 
                  <img className={!isEmpty(corporateLogo) && !isEmpty(corporateLogo.value) ? toUpper(corporateLogo.value) : ''} id={"corporateLogoItem"} aria-label={`corporate logo of ${corporateLogo.value}}`} src={corporateLogoUrl}></img>
                </li>
              }
              {
                initialData.isEntitled('CONTROL_BOX_INFO') &&
                <li id="infoTabLi"
                  title={this.props.docHeaderSectionJson.i18n.tooltip_information}
                  key={shortid.generate()}
                  className={[this.props.menuPaneStatus === 'infoTabButton' ? 'active' : 'inactive', this.shouldDisableINFOMenu(_pageName)].join(' ')}
                >
                  <a id="infoTabButton" aria-label="info tab button" role="button" onClick={(e) => this.topPaneEvent(e)}></a>
                  <div className={this.props.menuPaneStatus === 'infoTabButton' ? 'showTabPane' : 'hideTabPane'}>
                    <i className="arrow"></i>
                  </div>
                </li>
              }
              {
                MENU_CHECK.showTOC(this.props.docHeaderSectionJson.TableOfContents) && initialData.isEntitled('CONTROL_BOX_TOC') &&
                (
                  <li id="tocTabLi"
                    title={this.props.docHeaderSectionJson.i18n.tooltip_TOC}
                    key={shortid.generate()}
                    className={[this.props.menuPaneStatus === 'tocTabBtn' ? 'active' : 'inactive', this.shouldDisableTOCMenu(_pageName)].join(' ')}
                  >
                    <a id="tocTabBtn" aria-label="table of content tab button" role="button" onClick={(e) => this.topPaneEvent(e)}></a>
                    <div className={this.props.menuPaneStatus === 'tocTabBtn' ? 'showTabPane' : 'hideTabPane'}>
                      <i className="arrow"></i>
                      <div className="tocPane pane">
                        <div className="paneInnerFrame">
                          <TOCContainer />
                        </div>
                      </div>
                    </div>
                  </li>
                )
              }
              {
                MENU_CHECK.showTags(this.props.docHeaderSectionJson.issuerPage) && initialData.isEntitled('CONTROL_BOX_LABELS') && !window.HTML_RENDITION.isOffCuffList &&
                (
                  <li id="tagsTabLi"
                    title={this.props.docHeaderSectionJson.i18n.tooltip_labels}
                    key={shortid.generate()}
                    className={[this.props.menuPaneStatus === 'tagsTabBtn' ? 'active' : 'inactive', this.shouldDisableTAGMenu(_pageName)].join(' ')}
                  >
                    <a id="tagsTabBtn" aria-label="tags tab button" role="button" onClick={(e) => this.topPaneEvent(e)}></a>
                    <div className={this.props.menuPaneStatus === 'tagsTabBtn' ? 'showTabPane' : 'hideTabPane'}>
                      <i className="arrow"></i>
                      <div className="tagsPane pane">
                        <div className="paneInnerFrame">
                          <TagsContainer />
                        </div>
                      </div>
                    </div>
                  </li>
                )
              } 
              {
                (
                  <li id="printTabLi"
                    title={this.props.docHeaderSectionJson.i18n.tooltip_print}
                    key={shortid.generate()}
                  >
                    <a id="printTabBtn" aria-label="print tab button" role="button" onClick={(e) => this.topPaneEvent(e)}><PrintTabContainer isMobile={true} /></a>                    
                  </li>
                )
              }
              {
                initialData.isEntitled('CONTROL_BOX_SHARE') && !window.HTML_RENDITION.isOffCuffList &&
                <li id="shareTabLi"
                  title={this.props.docHeaderSectionJson.i18n.tooltip_share_action}
                  key={shortid.generate()}
                  className={this.props.menuPaneStatus === 'shareTabButton' ? 'active' : 'inactive'}
                >
                  <a id="shareTabButton" aria-label="share tab button" role="button" onClick={(e) => this.topPaneEvent(e)}></a>
                  <div className={this.props.menuPaneStatus === 'shareTabButton' ? 'showTabPane' : 'hideTabPane'}>
                    <i className="arrow"></i>
                    <div className="shareTabPane pane">
                      <div className="paneInnerFrame">
                        <MoreContainer />
                      </div>
                    </div>
                  </div>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    );
  }

  public whiteBar() {
    const expandIcon =
      (window.HTML_RENDITION.isBlogPrintMode || window.HTML_RENDITION.isOffCuffList) &&
      <div className={"expand-all " + (this.props.expandAll ? 'expand-bottom' : 'expand-right')} onClick={() => this.handleExpandClick()}></div>;
    return (
      <div id="white-bar" className="hide hidden-xs">
        <div className="headline-scroll-header">
          <div className='citi-logo' role="img" aria-label="citi logo"></div>
          <div className="white-bar-text">
            {expandIcon}
            {getCopyHeadline(this.props.offTheCuffTitle)}
          </div>
          {
            this.props.showLHS && !this.props.isFetching && this.state.showLeftFloatPanel && !this.props.showOldBranding && (
              <div className='scroll-header'>
                <LeftMenuPartTemplate docTitle={this.props.docTitle} showOldBranding={this.props.showOldBranding} />
              </div>
          )}
        </div>
        <div id="process-bar"></div>
      </div>
    );
  }

  public renderHeaderDom() {
    return (
      <React.Fragment>
        {this.state.isDeviceScreenType ? this.headerMobileScreen() : this.headerPcScreen()}
      </React.Fragment>
    );
  }

  public loadBranding() {
    let Branding: any;

    if (this.props.showOldBranding) {
      Branding = RenditionLoadable({
        loader: () => import('../../dynamicComponents/headerOld'),
      }, "headerOld", Date.now());
    }
    else {
      Branding = RenditionLoadable({
        loader: () => import('../../dynamicComponents/headerNew'),
      }, "headerNew", Date.now());
    }

    return <Branding/>;
  }

  public render() {
    return (
      <div role="banner">
        {this.loadBranding()}
        {this.renderHeaderDom()}
      </div>
    );
  }

  private handleExpandClick() {
    RSCH_HTML_TRACKING_CONFIG.trackBlogExpandAll();
    $('#offcuff-banner .expand-all').click();
  }
}

const mapStateToProps = (state: IReducerState) => {
  return {
    docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
    initialData: state.asyncStateReducer.initialData,
    switchPageData: state.commonStateReducer.switchPageData,
    menuPaneStatus: state.commonStateReducer.menuPaneStatus,
    offTheCuffTitle: state.commonStateReducer.offTheCuffTitle,
    expandAll: state.offCuffListStateReducer.expandAll,
  };
};

export default connect(mapStateToProps)(Header);